/* eslint-disable no-undef */
import {
    formatRefNumber,
    formatDate,
    clearActive,
    toggleArrow
} from "./unclaimedMoneyHelpers";

(function () {
    /**
     * @module unclaimedSearch
     */

    let unclaimedSearch = {};

    // Elements
    const wrapperElement = document.querySelector('.unclaimed-search');
    const resultsElement = document.querySelector("#unclaimed-search__results");
    const errorElement = document.querySelector(".unclaimed-search__error");
    const loaderElement = document.querySelector(".results__loader");
    const searchButton = document.getElementById("searchButton");
    const paginationList = document.querySelector(
        ".qld__search-pagination__list"
    );
    const searchBar = document.getElementById("nameTextBox");
    const checkboxWrapper = document.querySelector(
        ".unclaimed-search__checkbox"
    );
    const checkbox = document.getElementById("tcCheckBox");
    const sortWrapper = document.querySelector(".unclaimed-search__sort-buttons")
    const sorters = document.querySelectorAll(".unclaimed-search__sort");
    const sortOptions = document.querySelector(`[data-role="sort-type"]`);

    if (!sortOptions) return;

    // Static HTML buttons
    const backBtnHTML = `
        <li class="prev">
            <a href="#" id="page-back" class="qld__search-pagination_link" aria-label="Previous page of results">
                <svg class="qld__icon qld__icon--sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="16" height="16" role="img"><path fill="currentColor" d="M448 256C448 264.8 440.6 272 431.4 272H54.11l140.7 149.3c6.157 6.531 5.655 16.66-1.118 22.59C190.5 446.6 186.5 448 182.5 448c-4.505 0-9.009-1.75-12.28-5.25l-165.9-176c-5.752-6.094-5.752-15.41 0-21.5l165.9-176c6.19-6.562 16.69-7 23.45-1.094c6.773 5.938 7.275 16.06 1.118 22.59L54.11 240h377.3C440.6 240 448 247.2 448 256z"></path></svg>
            </a>
        </li>`;
    const nextBtnHHTML = `
        <li class="next">
            <a href="#" id="page-next" class="qld__search-pagination_link" aria-label="Next page of results">
                <svg class="qld__icon qld__icon--sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" width="16" height="16" role="img"><path fill="currentColor" d="M443.7 266.8l-165.9 176C274.5 446.3 269.1 448 265.5 448c-3.986 0-7.988-1.375-11.16-4.156c-6.773-5.938-7.275-16.06-1.118-22.59L393.9 272H16.59c-9.171 0-16.59-7.155-16.59-15.1S7.421 240 16.59 240h377.3l-140.7-149.3c-6.157-6.531-5.655-16.66 1.118-22.59c6.789-5.906 17.27-5.469 23.45 1.094l165.9 176C449.4 251.3 449.4 260.7 443.7 266.8z"></path></svg>
            </a>
        </li>`;

    // Error messages
    const noResultsError = `There are no results matching your search criteria:`;
    const noSearchTermError = `Please enter your name.`;
    const apiError = `Your search cannot connect at the moment. We apologise for any inconvenience. Please try again later.`;

    let prevWidth = window.innerWidth;

    /**
     * Make API call and return search data
     *
     * @param {string} query
     * @param {number} offset
     * @param {string} dateOrder
     * @returns API data
     */
    async function fetchData(query, offset) {
        const baseURL =
            "https://www.pt.qld.gov.au/utilities/unclaimed-money-api";
        const limit = 15;

        offset = offset || 0;

        let currentSort = document.querySelector(
            ".unclaimed-search__sort.active"
        );
        let currentSortValue = `${currentSort.getAttribute(
            "id"
        )}+${currentSort.getAttribute("data-sort")}`;

        try {
            errorElement.innerHTML = "";
            resultsElement.innerHTML = "";
            paginationList.innerHTML = "";
            loaderElement.style.display = "";
            if (searchButton.getBoundingClientRect().bottom < 0) {
                wrapperElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            const response = await fetch(
                `${baseURL}?q=${query}&limit=${limit}&offset=${offset}&sort=${currentSortValue}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json();
            loaderElement.style.display = "none";
            return data;
        } catch (error) {
            unclaimedSearch.errorMsg(apiError);
            console.error(error);
            loaderElement.style.display = "none";
        }
    }

    /**
     *  Display error messages
     *
     * @param {string} message - predefined message
     * @param {string} query - search term
     */
    unclaimedSearch.errorMsg = function (message, query) {
        resultsElement.innerHTML = "";
        paginationList.innerHTML = "";
        sortWrapper.style.display = "none";
        errorElement.innerHTML = `${message} ${query ? query : ""}`;
        errorElement.style.display = "";
    };

    /**
     * Display results
     *
     * @param {object} data - search data from API
     * @param {number} pageNumber - page number from pagination click
     */
    unclaimedSearch.renderResults = function (data, pageNumber) {
        // show filters
        sortWrapper.style.display = "flex"

        // build results
        const results = data.result.records;
        results.forEach((result) => {
            const resultHTML = `
                <li class="col-xs-12 col-md-6 col-lg-4">
                    <div class="qld__card">
                        <div class="qld__card__inner">
                            <div class="qld__card__content">
                                <div class="qld__card__content-inner">
                                    <h3 class="qld__card__title">${result.Owner}</h3>
                                    <hr class="qld__horizontal-rule">
                                    <p class="qld__card__description">
                                        <p><strong>Reference no.:</strong> ${formatRefNumber(result.ClientId_ActNo)}</p>
                                        <p><strong>Sender:</strong> ${result.SenderName}</p>
                                        <p><strong>Post code:</strong> ${result.PCode}</p>
                                        <p><strong>Date:</strong> ${formatDate(result.DateRec)}</p>
                                        <p><strong>Amount:</strong> $${result.Amount}</p>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            `;
            resultsElement.innerHTML += resultHTML;
        });

        // check for mobile
        const isMobile = window.innerWidth < 700 ? true : false

        unclaimedSearch.renderPagination(isMobile, data.result.total, pageNumber);
    };

    /**
     * Render pagination HTML
     * 
     * @param {boolean} isMobile
     * @param {number} total
     * @param {number} pageNumber
     */
    unclaimedSearch.renderPagination = function (isMobile, total, pageNumber) {
        paginationList.innerHTML = "";

        // build pagination
        const requiredPages = Math.ceil(total / 15);
        const maxPagesToShow = isMobile ? 4: 10;
        let startPage, endPage;

        if (requiredPages < 2) return;

        // calculate start and end pages based on current page
        if (requiredPages <= maxPagesToShow) {
            startPage = 1;
            endPage = requiredPages;
        } else {
            if (pageNumber <= (isMobile ? 3: 5)) {
                startPage = 1;
                endPage = maxPagesToShow;
            } else if (pageNumber + (isMobile ? 2 : 4) >= requiredPages) {
                startPage = requiredPages - maxPagesToShow + 1;
                endPage = requiredPages;
            } else {
                startPage = pageNumber - (isMobile ? 1 : 4);
                endPage = pageNumber + (isMobile ? 2 : 5);
            }
        }

        // create links
        paginationList.innerHTML += backBtnHTML;
        for (let index = startPage; index <= endPage; index++) {
            const pageLinkHTML = `
                <li class="num">
                    <a id="page-${index}" href="#" class="qld__search-pagination_link num-link">${index}</a>
                </li>
            `;
            paginationList.innerHTML += pageLinkHTML;
        }
        paginationList.innerHTML += nextBtnHHTML;

        // add event listeners to links to trigger search for that page
        const pageLinks = document.querySelectorAll(".qld__search-pagination_link.num-link");
        pageLinks.forEach((link) => {
            link.addEventListener("click", function (event) {
                event.preventDefault();
                const pageNumber = parseInt(link.innerText);
                unclaimedSearch.search(pageNumber);
            });
        });

        // add functionality to next and back buttons
        const backBtn = document.getElementById("page-back");
        const nextBtn = document.getElementById("page-next");
        backBtn.addEventListener("click", function (e) {
            e.preventDefault();
            unclaimedSearch.search(pageNumber - 1);
        });
        nextBtn.addEventListener("click", function (e) {
            e.preventDefault();
            unclaimedSearch.search(pageNumber + 1);
        });
        if (pageNumber === 1) backBtn.parentElement.style.display = "none";
        if (pageNumber == requiredPages) nextBtn.parentElement.style.display = "none";

        // add active link class
        const activeLink = document.getElementById(`page-${pageNumber}`);
        clearActive(pageLinks);
        activeLink.parentElement.classList.add("active");
    }

    /**
     * Perform a search and run renderResults function
     *
     * @param {number} pageNumber - the page number for pagination
     */
    unclaimedSearch.search = async function (pageNumber) {
        const query = searchBar.value;
        errorElement.style.display = "none";
        if (query.length === 0) {
            unclaimedSearch.errorMsg(noSearchTermError);
            return;
        }

        const offset = pageNumber === 1 ? 0 : (pageNumber - 1) * 15;
        const data = await fetchData(query, offset);

        if (data.result.records.length > 0) {
            checkboxWrapper.style.display = "none";
            paginationList.setAttribute('data-total', data.result.total);
            paginationList.setAttribute('data-page', pageNumber);
            this.renderResults(data, pageNumber);
        } else {
            this.errorMsg(noResultsError, query);
        }
    };

    /**
     * Window resize handler
     */
    unclaimedSearch.resizeHandler = function () {
        const curWidth = window.innerWidth;
        if (paginationList.hasChildNodes()) {
            const total = parseInt(paginationList.getAttribute('data-total'));
            const page = parseInt(paginationList.getAttribute('data-page'))

            if (prevWidth <= 700 && curWidth > 700){
                unclaimedSearch.renderPagination(false, total, page);
            } else if (prevWidth > 700 && curWidth <= 700) {
                unclaimedSearch.renderPagination(true, total, page);
            }
        }
        prevWidth = curWidth;
    }

    // sort by options, enables sorting by various categories
    if (sortOptions) {
        sortOptions.addEventListener("click", (e) => {
            const opened = document.querySelector(`[data-role="sort-options"]`);
            const icon = sortOptions.querySelector("i");

            if (opened) {
                toggleArrow(icon, "down");

                opened.remove();

                return;
            }

            const searchWrapper = document.querySelector(`[data-role="option-search-wrapper"]`);
            const options = document.createElement("div");
            const sortBy = [ 
                { code: "DateRec", name: "date", title: "Date" },
                { code: "ClientId_ActNo", name: "reference no", title: "Reference No" },
                { code: "Owner", name: "owner", title: "Owner" },
                { code: "SenderName", name: "sender name", title: "Sender Name" },
                { code: "PCode", name: "post code", title: "Post Code" },
                { code: "Amount", name: "amount", title: "Amount" } 
            ];

            toggleArrow(icon, "up");

            // sort option button
            sortBy.forEach(({ code, name, title }, i) => {
                const sortButton = document.createElement("button");

                sortButton.type = "button";
                sortButton.textContent = title;
                sortButton.dataset.cat = code;
                sortButton.dataset.name = name;
                sortButton.dataset.role = "filter-search";
                sortButton.classList.add("unclaimed-search__cat");

                options.append(sortButton);
            });

            // options wrapper
            options.dataset.role = "sort-options";
            options.classList.add("unclaimed-search__sort-options");

            searchWrapper.append(options);
        });
    }

    document.addEventListener("click", (e) => {
        const opened = document.querySelector(`[data-role="sort-options"]`);
        const icon = sortOptions.querySelector("i");
        const { target } = e;

        // select an option to sort by
        if (target.dataset && target.dataset.role === "filter-search") {
            const title = document.querySelector(`[data-role="filter-title"]`);
            const currentSort = document.querySelector(".unclaimed-search__sort.active");

            toggleArrow(icon, "down");

            title.innerHTML = `Sort by ${ target.dataset.name }`;
            currentSort.id = target.dataset.cat;
            unclaimedSearch.search(1);

            opened.remove();
        }
    });

    /**
     * User actions
     */
    window.addEventListener("DOMContentLoaded", function () {
        // click checkbox
        if (checkbox) {
            checkbox.addEventListener("change", function () {
                this.checked
                    ? (searchButton.disabled = false)
                    : (searchButton.disabled = true);
            });
        }

        // basic search with button
        if (searchButton) {
            searchButton.addEventListener("click", function () {
                unclaimedSearch.search(1);
            });
        }

        // basic search with enter key
        if (searchBar) {
            searchBar.addEventListener("keydown", function(e) {
                if (e.key === "Enter" && checkbox.checked) {
                    unclaimedSearch.search(1);
                }
            });
        }

        // update sort order
        if (sorters) {
            sorters.forEach((button) => {
                button.addEventListener("click", function () {
                    clearActive(sorters);
                    let currentOrder = this.getAttribute("data-sort");
                    let icon = this.querySelector("i");
                    const title = this.querySelector(`[data-role="button-title"]`);

                    const currentOrderTitle = currentOrder === "asc" ? "Desc" : "Asc";

                    currentOrder = currentOrder === "asc" ? "desc" : "asc";

                    title.textContent = currentOrderTitle;
                    currentOrder === "asc" ? toggleArrow(icon, "up") : toggleArrow(icon, "down");
                    this.setAttribute("data-sort", currentOrder);
                    this.classList.add("active");
                    unclaimedSearch.search(1);
                });
            });
        }
    });

    if (wrapperElement) {
        window.addEventListener('resize', QLD.utils.debounce(unclaimedSearch.resizeHandler, 250));
    }
})();
